import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'

export interface FAQQuestion {
    question: string
    answer: string
}

export interface FAQData {
    title: string
    questions: FAQQuestion[]
}

export interface FAQResponse {
    faq_data: {
        en: FAQData
        ar: FAQData
    }
}


const baseQueryWithRetry = retry(
    fetchBaseQuery({
        baseUrl: '',
        prepareHeaders: headers => {
            headers.set('Accept', 'application/json')
            headers.set('Content-Type', 'application/json')
            headers.set('Cache-Control', 'no-cache')
            return headers
        }
    }),
    {
        maxRetries: 0
    }
)

export const walletFAQApi = createApi({
    reducerPath: 'walletFAQApi',
    baseQuery: baseQueryWithRetry,
    tagTypes: ['WalletFAQ'],
    endpoints: builder => ({
        getWalletFAQ: builder.query<FAQResponse, void>({
            query: () => ({
                url: process.env.NEXT_PUBLIC_WALLET_FAQ_URL || '',
                method: 'GET'
            }),
            providesTags: ['WalletFAQ']
        })
    })
})

export const { useGetWalletFAQQuery } = walletFAQApi
export default walletFAQApi
